@if (hasLabel) {
  <div class="form-field__label form-field__label--external">
    @if (field.label; as label) {
      {{ label | translateInline }}
    }
  </div>
}

<div class="text-box-field">
  <div class="text-box-field__content" [innerHTML]="htmlContent$ | async"></div>
  @if (imageSrc$ | async; as imageSrc) {
    <img
      [src]="imageSrc"
      class="text-box-field__disclaimer-image"
      alt="disclaimer image"
    />
  }
</div>
